import DisplayableError, { UNDERWRITING_ISSUE, LEVEL_ERROR } from './DisplayableError';

export default class UnderwritingIssueDE extends DisplayableError {
    constructor(underwritingIssue) {
        const {
            longDescription,
            shortDescription,
            canUserApprove,
            offering,
            hasApprovalOrRejection,
            currentBlockingPoint,
            originalDTO
        } = underwritingIssue;
        super({
            id: `${originalDTO.publicID} - ${offering} - ${longDescription}`,
            title: shortDescription,
            description: longDescription,
            type: UNDERWRITING_ISSUE,
            level: LEVEL_ERROR,
            wizardSteps: [],
            isHidden: currentBlockingPoint === 'NonBlocking' || hasApprovalOrRejection
        });
        this.hasApprovalOrRejection = hasApprovalOrRejection;
        this.canUserApprove = canUserApprove;
        this.offering = offering;
        this.originalDTO = originalDTO;
        this.currentBlockingPoint = currentBlockingPoint;
    }
}